<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-22 09:37:16
 * @LastEditTime: 2020-11-17 11:29:43
-->
<template>
  <div v-if="dialogVisible">
    <el-dialog
      :title="$t('lang.usercontrol.user_exists')"
      :visible.sync="dialogVisible"
      width="50"
      center>
      <div class="concen">
        <el-form :model="modificationuser" :rules="rules" ref="editUserForm" label-width="150px" label-position="right">
          <el-form-item :label="`${$t('lang.usercontrol.UserGroup')}：`" prop="username">
            <el-input
              size="mini"
              v-model="modificationuser.username"
              class="adduserinput"
              :disabled="true"
              :placeholder="$t('lang.usercontrol.Mandatory')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.NICKNAME_RE')}：`">
            <el-input
              size="mini"
              v-model="modificationuser.nickname"
              class="adduserinput"
              :placeholder="$t('lang.usercontrol.Optional')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.FILE_REAL_H')}：`">
            <el-input
              size="mini"
              v-model="modificationuser.realname"
              class="adduserinput"
              :placeholder="$t('lang.usercontrol.Optional')">
            </el-input>
          </el-form-item>
          <el-form-item v-if="modificationuser.roleid" :label="`${$t('lang.usercontrol.user_admin')}：`" prop="roleid">
            <el-select
              v-model="modificationuser.roleid"
              :placeholder="$t('lang.usercontrol.Optional')"
              class="adduserinput"
              size="mini">
              <el-option
                v-for="item in roleId"
                :key="item.roleId"
                :label="item.roleName"
                :value="item.roleId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.phone')}：`" prop="user_tel">
            <el-input
              size="mini"
              v-model="modificationuser.user_tel"
              class="adduserinput"
              clearable
              :placeholder="$t('lang.usercontrol.Mandatory')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.socialize')}：`">
            <el-input
              size="mini"
              v-model="modificationuser.user_qq"
              class="adduserinput"
              :placeholder="$t('lang.usercontrol.Optional')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.email')}：` " prop="user_email">
            <el-input
              size="mini"
              v-model="modificationuser.user_email"
              class="adduserinput"
              :placeholder="$t('lang.usercontrol.Mandatory')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.address')}：`"  >
            <el-input
              size="mini"
              v-model="modificationuser.user_addr"
              class="adduserinput"
              :placeholder="$t('lang.usercontrol.Optional')">
            </el-input>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.notesData')}：`">
            <el-input
              size="mini"
              v-model="modificationuser.user_remarks"
              class="adduserinput"
              :placeholder="$t('lang.usercontrol.Optional')">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">{{$t('lang.usercontrol.cancel')}}</el-button>
        <el-button
          type="primary"
          size="mini"
          @click="submitEdit"
        >{{$t('lang.usercontrol.Determine')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash'
import { registerUser, updateUser, getFunctionalAuthority } from "@/api/usercontrol";
import { getuser_iscustomer, getuser_ctid } from "@/localStorage/localStorage";
import { rules, setLevel } from './formConfig'
export default {
  data() {
    return {
      dialogVisible: false,
      modificationuser: {},
      roleId: [],
      rules: rules
    }
  },
  methods: {
    show(item) {
      //获取权限列表
      getFunctionalAuthority(this.$i18n.locale == "en-US" ? 1 : 0).then(res => {
        this.roleId = res.data.data.list;
      });
      this.modificationuser = cloneDeep(item)
      this.dialogVisible = true 
    },
    // 提交编辑
    submitEdit() {
      this.$refs.editUserForm.validate(valid => {
        if(valid) {
          if (this.modificationuser.user_iscustomer == this.$t("lang.usercontrol.usertype1")) {
            this.modificationuser.user_iscustomer = "0";
          } else if (this.modificationuser.user_iscustomer == this.$t("lang.usercontrol.usertype3")) {
            this.modificationuser.user_iscustomer = "1";
          } else if (this.modificationuser.user_iscustomer == this.$t("lang.usercontrol.usertype2")) {
            this.modificationuser.user_iscustomer = "1";
          }
          updateUser(this.modificationuser).then(res => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: this.$t("lang.usercontrol.message9"),
                type: "success"
              });
              this.$emit('queryKeyword')
              this.dialogVisible = false
            } else {
              this.$message({
                showClose: true,
                message: this.$t("lang.usercontrol.message10"),
                type: "warning"
              });
            }
          });
        }else{
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.adduserinput {
  width: 4rem;
}
.concen{
  display: flex;
  justify-content: center;
}
</style>